(function () {
  const summary = document.querySelector('[data-gallery-summary]');
  if (!summary) return;

  const readValue = (field) => {
    const select = field.querySelector('select');
    if (select) {
      const opt = select.options[select.selectedIndex];
      return (opt && opt.text ? opt.text : select.value).trim();
    }
    const sv = field.querySelector('[data-selected-value]');
    return sv ? sv.textContent.trim() : '';
  };

  const update = () => {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;
    variantSelects.querySelectorAll('[data-option-name]').forEach((field) => {
      const name = field.getAttribute('data-option-name');
      const target = summary.querySelector(`[data-summary-option="${CSS.escape(name)}"]`);
      if (!target) return;
      const value = readValue(field);
      if (value) target.textContent = value;
    });
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
      requestAnimationFrame(update);
    });
  }

  update();
})();
